import { useEffect, useLayoutEffect, useState, type RefObject } from "react";
import { useInView } from "react-intersection-observer";

type AutoLoadMoreOnScrollProps = {
  rootRef: RefObject<HTMLElement | null>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
  rootMargin?: string;
};

export const AutoLoadMoreOnScroll = ({
  rootRef,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  rootMargin = "200px 0px"
}: AutoLoadMoreOnScrollProps) => {
  const [scrollRoot, setScrollRoot] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setScrollRoot(rootRef.current);
  }, [rootRef]);

  const { ref, inView } = useInView({
    root: scrollRoot ?? undefined,
    rootMargin,
    threshold: 0,
    skip: !scrollRoot
  });

  useEffect(() => {
    if (!inView) return;
    if (!hasNextPage) return;
    if (isFetchingNextPage) return;
    onLoadMore();
  }, [inView, hasNextPage, isFetchingNextPage, onLoadMore]);

  return <div ref={ref} className="h-1 w-full" />;
};
